import { hideGlobalPrompt, showGlobalPrompt } from '@store/actions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ElectricCarAddressForm from '../address-form';
import { useHasGridXAutopilotChargingReadScope } from '@tools/utils/hooks';
import { checkForScopes } from '@tools/utils/scopes';
import { Scope } from '@tools/enums/scopes';
import { useHasElectricCar } from '@store/branches/emobility/electric-car/selectors';
import { useSiteAddress } from '@store/branches/user/selectors';

export const useIsRequiredReCollectAddress = () => {
    const hasGridXAutopilotChargingReadScope =
        useHasGridXAutopilotChargingReadScope();
    // check for ME_WRITE scope to avoid showing the prompt to users who don't have the permission to update the address, as they would get stuck
    const hasMeWriteScope = checkForScopes([Scope.ME_WRITE]);
    const hasElectricCar = useHasElectricCar();
    const siteAddress = useSiteAddress();

    return (
        hasGridXAutopilotChargingReadScope &&
        hasMeWriteScope &&
        hasElectricCar &&
        !siteAddress
    );
};

export const useAddressPrompt = () => {
    const dispatch = useDispatch();

    const onSuccess = useCallback(() => {
        dispatch(hideGlobalPrompt());
    }, [dispatch]);

    const showAddressPrompt = useCallback(() => {
        dispatch(
            showGlobalPrompt({
                className: 'is--vertical-centered',
                children: (
                    <ElectricCarAddressForm
                        onSuccess={onSuccess}
                        inline={false}
                        isReCollectAddressPrompt
                    />
                ),
            }),
        );
    }, [dispatch, onSuccess]);

    return {
        showAddressPrompt,
    };
};
